var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBatchIdeal = function SvgBatchIdeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.301,
    cy: 9.301,
    r: 6.5,
    stroke: "currentColor",
    strokeOpacity: 0.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.47,
    d: "M2.227.124c.242-.242.55-.103.608.19l.527 2.57c.066.323-.139.543-.476.47l-2.563-.52c-.308-.066-.44-.367-.198-.616zm8.042 10.122c-.483.476-1.172.476-1.648 0-.088-.096-.227-.286-.315-.403L5.846 6.29c-.125-.176-.089-.345.014-.462.11-.102.286-.139.461-.015l3.553 2.469c.117.08.307.22.395.307.483.484.483 1.172 0 1.656"
  })));
};
export default SvgBatchIdeal;